import { useQuery } from "@tanstack/react-query";
import { useActiveClient } from "./client";

export function useBalance(type){
  let twinClient = useActiveClient();
  return useQuery({
    queryKey: ["GET", twinClient.url, "/dq", `/${type}` ],
    queryFn: async function () {
      return await twinClient.balance(type);
    },
    enabled: !!type
  })
}
